













import { Vue, Prop, Component, Watch } from 'vue-property-decorator'
import Chart from '@/components/Chart/index.vue'
import ChartHeader from './ChartHeader.vue'

  @Component({
    name: 'MainTitle',
    components: { Chart, ChartHeader }
  })
export default class extends Vue {
    @Prop({ default: '均分' }) private type!: string

    @Prop({ default: '#00B66C' }) private color!: string
    @Prop({ default: '#E9E9E9' }) private standardColor!: string
    @Prop({ default: '#979797' }) private standardBorderColor!: string

    @Prop({ default: '#666' }) private differenceColor!: string
    @Prop({ default: '#00B66C' }) private valueColor!: string
    @Prop({ required: true }) private dataList: any
    private legend: any[] = [{ name: '参考标准', color: '#666666' }, { name: this.type, color: this.valueColor }]

    private normScore: number = 0
    private avgScore: number = 0
    private name = ''
    private option: any = {}
    private chartId: string = ''

    @Watch('dataList', { immediate: true, deep: true })
    onDataChange(val: any) {
      if (!this.dataList.length) return

      // let name = []
      // let data = []
      // let normData = []
      // this.dataList.map((item: any) => {
      // })
      this.name = this.dataList[1].name
      this.normScore = this.dataList[0].values[0]
      this.avgScore = this.dataList[1].values[0]

      this.option = {
        grid: {
          top: 20,
          right: 10,
          left: 30
        },
        xAxis: {
          type: 'category',
          data: ['参考标准', '', this.name],
          splitLine: {
            show: false
          },
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            color: '#666666'
          }
        },
        yAxis: {
          type: 'value',
          splitLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
          axisLabel: {
            color: '#999999'
          }
        },
        animation: false,
        series: [
          {
            stack: '总量',
            barWidth: 22,
            data: [{
              value: 0,
              itemStyle: {
                color: '#FFFFFF'
              }
            },
            {
              value: Math.min(this.normScore, this.avgScore),
              itemStyle: {
                color: '#FFFFFF'
              }
            },
            {
              value: 0,
              itemStyle: {
                color: '#FFFFFF'
              }
            }
            ],
            markLine: {
              symbol: 'none',
              lineStyle: {
                type: 'dotted',
                color: '#979797'
              },
              data: [
                [
                  {
                    coord: ['参考标准', this.normScore]
                  },
                  {
                    coord: ['', this.normScore]
                  }
                ],
                [
                  {
                    coord: [this.name, this.avgScore]
                  },
                  {
                    coord: ['', this.avgScore]
                  }
                ]
              ]
            },
            type: 'bar',
            z: 9
          },
          {
            z: 10,
            stack: '总量',
            barWidth: 22,
            data: [
              {
                value: this.normScore,
                itemStyle: {
                  color: this.standardColor,
                  borderColor: this.standardBorderColor,
                  borderType: 'dotted'
                },
                label: {
                  show: true,
                  color: '#666666',
                  position: 'top',
                  formatter: this.type === '均分' ? '{c}' : '{c}%'
                }
              },
              {
                value: Math.abs((this.normScore - this.avgScore).toFixed(2)),
                itemStyle: {
                  color: this.differenceColor
                },
                label: {
                  show: true,
                  color: '#666',
                  position: 'top',
                  formatter: (v) => {
                    // console.log(this.avgScore, this.normScore, this.avgScore < this.normScore)
                    if (parseFloat(this.avgScore) < parseFloat(this.normScore)) {
                      return `-${v.value}` + (this.type === '均分' ? '' : '%')
                    } else if (parseFloat(this.avgScore) === parseFloat(this.normScore)) {
                      return `${v.value}` + (this.type === '均分' ? '' : '%')
                    } else {
                      return `+${v.value}` + (this.type === '均分' ? '' : '%')
                    }
                  }
                }
              },
              {
                value: this.avgScore,
                itemStyle: {
                  color: this.valueColor
                },
                label: {
                  show: true,
                  color: '#666',
                  position: 'top',
                  formatter: this.type === '均分' ? '{c}' : '{c}%'
                }
              }
            ],
            type: 'bar'
          }
        ]
      }
      // this.option.series[1].data[0].name = data
      // this.option.series[2].data[0].value = data
      // this.option.series[3].data[0].value = normData
      // this.option.xAxis[0].data = name
      // this.option.series[0].data = normData
      // this.option.series[1].data = data
      // this.option.series[0].data = this.dataList.map((item:any) => {
      //   item.value = item.values[0]
      //   return item
      // })
      this.$nextTick(() => {
        (this.$refs.chart as any).update()
      })
    }
    created() {
      this.chartId = new Date().getTime() + '_' + parseInt(Math.random() * 10000000 + '')
    }
}
